export enum InquiryFields {
  inquiryType = "inquiry_type",
  title = "title",
  industry = "industry",
  product = "product",
  employees = "employees",
  investmentForStart = "investment_for_start",
  yearsOnMarket = "years_on_market",
  customersCount = "customers_count",
  inquiryTurnoverMin = "inquiry_turnover_min",
  inquiryTurnoverMax = "inquiry_turnover_max",
  inquiryCost = "inquiry_cost",
  additionalInformation = "additional_information",
  monthlyIncomeMin = "monthly_income_min",
  monthlyIncomeMax = "monthly_income_max",
}

export interface InquirySettingsValues {
  inquiry_type: string;
  title: string;
  industry: string;
  product: string;
  employees: string;
  years_on_market: string;
  investment_for_start: number;
  customers_count: string;
  inquiry_turnover_min: number;
  inquiry_turnover_max: number;
  monthly_income_min: number;
  monthly_income_max: number;
  inquiry_cost: number;
  additional_information?: string;
}
